/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from 'zod';

import {conversationUser} from '../../modules/user/conversationUser';
import {userIdParams} from '../../modules/user/userIdParams';

export const updatePublicUserParams = userIdParams;

export type UpdatePublicUserParams = z.infer<typeof updatePublicUserParams>;

export const updatePublicUserBody = z.object({
  displayName: z
    .string()
    .min(1, 'Display name is required')
    .max(255, 'Display name cannot exceed 255 characters'),
});

export type UpdatePublicUserBody = z.infer<typeof updatePublicUserBody>;

export const updatePublicUserResponse = conversationUser
  .omit({type: true, externalUserId: true})
  .extend({
    type: z.literal('PUBLIC').openapi({
      description: 'Type of user',
      example: 'PUBLIC',
    }),
  });

export type UpdatePublicUserResponse = z.infer<typeof updatePublicUserResponse>;
